(() => {
  const bind = (el) => {
    if (el.dataset.idasStyleBound) return;
    el.dataset.idasStyleBound = 'true';

    let active = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;

    el.addEventListener('pointerdown', (event) => {
      if (event.button !== 0) return;
      active = true;
      moved = false;
      startX = event.clientX;
      startScroll = el.scrollLeft;
      el.setPointerCapture(event.pointerId);
    });

    el.addEventListener('pointermove', (event) => {
      if (!active) return;
      const dx = event.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = startScroll - dx;
    });

    const stop = () => {
      active = false;
    };

    el.addEventListener('pointerup', stop);
    el.addEventListener('pointercancel', stop);

    el.addEventListener('click', (event) => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    el.addEventListener('wheel', (event) => {
      if (el.scrollWidth <= el.clientWidth) return;
      if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;
      el.scrollLeft += event.deltaY;
      event.preventDefault();
    }, { passive: false });
  };

  const init = () => {
    document.querySelectorAll('[data-idas-style-drag]').forEach(bind);
  };

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
